import moment from 'moment';

export var CERTIFICATES_FILTERS_KEY = 'societario.certificados';

export var FILTER_BY_LABELS = { due_date: 'Vencimento', emission_date: 'Emissão' };

// Defaults depend on "today" (current year), so they are built at mount
// (usePersistedFilters). Everything is a string/array: JSON-serializable.
export var getDefaultCertificatesFilters = function() {
  return {
    year: moment().format('YYYY'),
    filterBy: 'due_date',
    visualizationMode: 'registered',
    statusFilters: [],
    typeFilters: [],
    natureFilters: [],
    search: '',
  };
};

// The year only applies together with a "filtrar por" date field; without it
// the server returns every certificate.
export var isYearApplied = function(filters) {
  return !!(filters.filterBy && filters.year);
};

// Turns the saved filter into the /certificates params (server-side part only).
export var getCertificatesRequest = function(filters) {
  if (!isYearApplied(filters)) return {};
  return {
    filter_by: filters.filterBy,
    from: filters.year + '-01-01',
    to: filters.year + '-12-31',
  };
};

// Same request => same server-side result (the rest is filtered client-side).
export var isSameCertificatesRequest = function(a, b) {
  return JSON.stringify(getCertificatesRequest(a)) === JSON.stringify(getCertificatesRequest(b));
};

// Changing the visualization clears the sub-filters (they depend on it).
export var getVisualizationChange = function(filters, visualizationMode) {
  if (visualizationMode === filters.visualizationMode) return { visualizationMode: visualizationMode };
  return { visualizationMode: visualizationMode, statusFilters: [], typeFilters: [], natureFilters: [] };
};

// Badge: only what differs from the defaults.
export var countActiveCertificatesFilters = function(filters, defaults) {
  return (filters.filterBy !== defaults.filterBy ? 1 : 0) +
    (isYearApplied(filters) && filters.year !== defaults.year ? 1 : 0) +
    (filters.visualizationMode !== defaults.visualizationMode ? 1 : 0) +
    (filters.statusFilters || []).length +
    (filters.typeFilters || []).length +
    (filters.natureFilters || []).length +
    (filters.search ? 1 : 0);
};

export var getFilterByLabel = function(filterBy) {
  if (!filterBy) return 'Todos os anos';
  return FILTER_BY_LABELS[filterBy] || filterBy;
};
